import { NEXT_PUBLIC_TENANT_ID } from '@/configs/env'
import axiosService from '@/lib/axios'
import { ResquestCommon } from '@/types/common'
import { ProductsRequest, ProductsResponse } from '@/types/product'

export function getProducts(params: ProductsRequest & ResquestCommon) {
  return axiosService.get<ProductsResponse>(`/v1/TenantProduct/${NEXT_PUBLIC_TENANT_ID}`, {
    params,
  })
}
